import { AdminMiniRunDraft } from './components/AdminMiniComposer';

/**
 * The activation payload, built the same way for both tools.
 *
 * Written once because the two `AdminSaveAndActivate` classes read the same keys, and a key spelled
 * differently by one caller fails the way HQAPI-123 did: quietly, with the server taking a default
 * and nobody being told. The Compliance Sniffer composer and the Mystery Shopper one now send an
 * identical shape, plus whatever `extra` their own route needs.
 *
 * @param draft what the admin assembled
 * @param extra the action, the admin's id, and anything only one tool has
 */
export function activationPayloadFor(
    draft: AdminMiniRunDraft,
    extra: Record<string, unknown>
): Record<string, unknown> {
    const payload: Record<string, unknown> = {
        ...extra,
        name: draft.name,
        senderMode: draft.sender.senderMode,
        scheduleType: draft.schedule.scheduleType,
        adminTargets: draft.targets,
        // **What scores the replies.** A run saved without these sends its mail, collects the
        // reply and is never graded, because both Nok processors read exactly this list.
        noks: draft.noks,
        companyId: draft.companyId === '' ? null : draft.companyId,
    };

    if (draft.sender.senderMode === 'nok') {
        payload.nokChoice = draft.sender.nokChoice;
        payload.fromChoice = draft.sender.fromChoice;
        // Only sent when one was actually chosen. `random` means "pick one for me", and HQ-API
        // stores whichever it picked so a queued send goes out as the same person as an
        // immediate one.
        if (draft.sender.nokChoice === 'nok') {
            payload.fromNok = draft.sender.fromNok;
        }
        if (draft.sender.fromChoice === 'persona') {
            payload.fromPersona = draft.sender.fromPersona;
        }
    } else {
        payload.fromName = draft.sender.fromName;
        payload.fromEmail = draft.sender.fromEmail;
    }

    if (draft.schedule.scheduleType === 'date') {
        payload.scheduledAt = draft.schedule.scheduledAt;
    }
    if (draft.schedule.startDate !== '') {
        payload.startDate = draft.schedule.startDate;
    }
    if (draft.schedule.endDate !== '') {
        payload.endDate = draft.schedule.endDate;
    }

    return payload;
}
